exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1LhW1{display:flex;flex-direction:row;align-items:center;justify-content:left;min-width:180px;padding:.5rem}.style_container__1LhW1 .style_additionalDetails__q5-QQ,.style_container__1LhW1 .style_tooltipTitle__1Z_Oc{margin-left:.5rem}.style_container__1LhW1 .style_tooltipTitle__1Z_Oc{color:#9e9e9e;opacity:0}.style_container__1LhW1:hover .style_tooltipTitle__1Z_Oc{opacity:1}.style_task-previous__mHeho{opacity:.65}.style_task-archived__G1KfB{opacity:.2}.style_details__10UKL{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding-left:.5rem}.style_taskName__z8Cch,.style_version__3y8GX{color:#333;font-weight:500;font-size:.9375rem;display:flex;align-items:center}.style_date__1SpQz{color:#666;font-weight:400;font-size:.6875rem}.style_taskLink__1_d2s:hover{background-color:hsla(0,0%,60%,.08)}", ""]);

// exports
exports.locals = {
	"container": "style_container__1LhW1",
	"additionalDetails": "style_additionalDetails__q5-QQ",
	"tooltipTitle": "style_tooltipTitle__1Z_Oc",
	"task-previous": "style_task-previous__mHeho",
	"taskPrevious": "style_task-previous__mHeho",
	"task-archived": "style_task-archived__G1KfB",
	"taskArchived": "style_task-archived__G1KfB",
	"details": "style_details__10UKL",
	"version": "style_version__3y8GX",
	"taskName": "style_taskName__z8Cch",
	"date": "style_date__1SpQz",
	"taskLink": "style_taskLink__1_d2s"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/projects/components/ProjectDashboard/TaskStatusDetails/style.less
// module id = 1457
// module chunks = 8